import { memo } from 'react'
import {Routes,Route} from 'react-router-dom';
import {default as MyApplication} from './MyApplication'
import {default as UpdateLevel} from './UpdateLevel'
import {default as UpdateStudentBioData} from './UpdateStudentBioData'


const Applications = () => {
  return (
    <Routes>
      <Route path="/" element={<MyApplication />}/>
      <Route path="/my-application" element={<MyApplication/>}/>
      <Route path="/update-level" element={<UpdateLevel/>}/>
      <Route path="/update-student-bio-data" element={<UpdateStudentBioData/>}/>

    </Routes>
  )
}

export default memo(Applications) 


const DefaultApplications = ()=>{
  return <div>Application</div>
}